import { z } from "zod";

export const ProdutoServicoSchema = z.object({
    descricao: z.coerce.string().nonempty("Nome do Produto/Servico é obrigatório."),
    ativo: z.boolean().default(true),
    tipo: z.coerce.number().default(1),
    unidade: z.coerce.string().nullable().default(null),
    norma: z.coerce.string().nullable().default(null),

});

export type ProdutoServicoForm = z.infer<typeof ProdutoServicoSchema>;

export const defaultProdutoServicoForm: Partial<ProdutoServicoForm> = {
    ativo: true,
    tipo: 0,

}